import moment from 'moment';

import {
  PatientInsuranceCardDto,
  PatientInsuranceBenefitChangeOperationEnum,
  PatientInsuranceBenefitChangeStatusEnum,
  INSURANCE_CARD_STATUSES,
} from '@monument/core';

export const shouldUpdateInsurance = (cards: PatientInsuranceCardDto[] | undefined) => {
  if (!cards) {
    return false;
  }

  const activeCard = cards.find(card => card.status === INSURANCE_CARD_STATUSES.ACTIVE);
  const mostRecentBenefitChange = cards
    ?.flatMap(card =>
      card.benefit?.changes?.sort(
        (a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf(),
      ),
    )
    .find(change => change);
  const shouldUpdateInsurance =
    !activeCard &&
    cards.length > 0 &&
    cards.every(
      card =>
        card.status === INSURANCE_CARD_STATUSES.INELIGIBLE ||
        card.status === INSURANCE_CARD_STATUSES.OPTED_OUT,
    ) &&
    (cards.every(card => moment().diff(moment(card.submissionDate), 'months') >= 12) ||
      (mostRecentBenefitChange?.operation !==
        PatientInsuranceBenefitChangeOperationEnum.AutoInitial &&
        mostRecentBenefitChange?.status === PatientInsuranceBenefitChangeStatusEnum.Ineligible &&
        moment().diff(moment(mostRecentBenefitChange.updatedAt), 'months') <= 3));

  return shouldUpdateInsurance;
};
